import { BookOpen, Users, LineChart, Brain, GraduationCap, FileText } from "lucide-react";
import { motion } from "framer-motion";

const features = [
  {
    icon: Users,
    title: "Virtual Classrooms",
    description: "Create and manage classrooms, invite students with a code, and collaborate effortlessly.",
  },
  {
    icon: FileText,
    title: "Smart Exams",
    description: "Build MCQ exams with marking, timers, and auto-grading. Assign to classrooms instantly.",
  },
  {
    icon: LineChart,
    title: "Live Analytics",
    description: "Track performance with detailed reports, leaderboards, and progress charts.",
  },
  {
    icon: Brain,
    title: "AI Tutor",
    description: "24/7 AI-powered doubt solving across all subjects. Get answers instantly.",
  },
];

const MinimalistFeatures = () => {
  return (
    <section className="py-24 px-6 bg-background">
      <div className="container mx-auto">
        {/* Bumble-style split layout */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-24">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-foreground leading-[1.05] tracking-tight">
              Everything you need to{" "}
              <span className="text-primary">teach & learn.</span>
            </h2>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <p className="text-lg text-muted-foreground leading-relaxed">
              A complete education platform built for Indian classrooms. From creating exams to AI-powered doubt solving — we've got everything covered.
            </p>
          </motion.div>
        </div>

        {/* Feature cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="bg-card rounded-3xl border p-8 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="h-14 w-14 rounded-2xl bg-primary/20 flex items-center justify-center mb-6 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                <feature.icon className="h-7 w-7 text-foreground group-hover:text-primary-foreground transition-colors" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">{feature.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MinimalistFeatures;
